export default __webpack_public_path__ + "static/media/SEN-POW-OWON.286a3ebb.png";